import { Button } from 'components/buttons/button';
import { ValidatedInput } from 'components/forms/input';
import { Layout } from 'components/layout';
import { useBasket } from 'lib/hooks/basket/use-basket';
import { useInput } from 'lib/hooks/use-input';
import { useState } from 'react';
import currency from 'currency.js';
import {
  GetUnstructuredDataDocument,
  GetUnstructuredDataQueryVariables,
  useGetUnstructuredDataQuery,
} from 'lib/graphql-generated';
import { GetServerSideProps } from 'next';
import { addApolloState, initializeApollo } from 'lib/hooks/apollo-client';
import { RenderContent } from 'components/content-renderer';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const client = initializeApollo();
  await client.query({
    query: GetUnstructuredDataDocument,
    variables: { title: 'pif' } as GetUnstructuredDataQueryVariables,
  });

  return addApolloState(client, { props: {} });
};

export const PifPage = () => {
  const amount = useInput<number>(5);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [basket, modifyBasket] = useBasket();
  const { data, loading } = useGetUnstructuredDataQuery({
    variables: { title: 'pif' },
  });

  return (
    <Layout pageName='Voucher'>
      <article className='[ order-1 grid grid-cols-1 gap-y-6 py-16 ] [ md:grid-cols-5 md:gap-y-8 md:max-w-screen-md md:px-4 md:pb-8 ] [ lg:max-w-screen-xl lg:grid-cols-7 lg:gap-x-8 lg:order-3 ] w-full justify-items-center mx-auto'>
        <img
          alt={`Image for lighthouse vouchers`}
          className='max-w-2xs sm:max-w-xs [ md:max-w-full md:col-span-2 ] [ ]'
          src={data.unstructured_data_by_pk.data.image}
        />
        <section className='prose px-8 md:col-span-5 md:col-start-1 justify-self-start md:px-0  [ lg:col-start-3 lg:col-span-3 lg:row-start-1 ] '>
          <RenderContent content={data.unstructured_data_by_pk.data.content} />
        </section>
        <section className='[ max-w-2xs sm:max-w-xs flex flex-col ] [ md:mb-auto md:flex-col md:col-span-3 ] [ lg:col-span-2 lg:col-start-6 ] flex-wrap '>
          <h1 className='max-w-2xs sm:max-w-xs'>
            <span className='bg-green-default text-white font-header tracking-wide uppercase pt-1 px-1 whitespace-pre-wrap text-2xl'>
              Pay It Forward Voucher
            </span>
          </h1>

          <div className='my-auto uppercase font-header tracking-wide text-2xl md:mt-4'>
            <ValidatedInput
              errorMessage={amount.value < 1 ? 'Amount must be £1 or more' : ''}
              showError={amount.value < 1}
              label='Voucher Value (£)'
              id='amount'
              name='amount'
              inputProps={{ min: 5 }}
              bind={{
                value: amount.value,
                onChange: (e) =>
                  amount.setValue(Math.round(parseInt(e.target.value))),
              }}
              type='number'
            />
            <Button
              className='md:mt-4 ml-auto my-auto md:ml-0'
              buttonType='primary'
              buttonSize='md'
              disabled={
                (amount.value < 1 && !!basket.pif) ||
                (basket.pif && !amount.isModified)
              }
              onClick={() => {
                modifyBasket({
                  type: 'modify-pif',
                  payload: currency(amount.value).intValue,
                });
                setSubmitted(true);
                amount.init(amount.value);
              }}>
              {basket.pif && amount.isModified
                ? 'Adjust Pif'
                : basket.pif
                ? 'In Basket'
                : 'Add To Basket'}
            </Button>
          </div>
        </section>
      </article>
    </Layout>
  );
};

export default PifPage;
